import { Box, Grid, Skeleton } from '@mui/material';
import { useQuery } from 'react-query';
import DateChip from 'src/components/DateChip';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import Subtitle from 'src/components/Subtitle';
import { getFiagroAssetData } from 'src/services/operation/operationFiagro';

import { formatDate } from '../utils';

export default function AssetData({ hash }: { hash: string }) {
  const { data, isLoading } = useQuery({
    queryKey: ['operationFIAGROAssetRecent', hash],
    queryFn: () => getFiagroAssetData(hash, 1),
  });

  const mostRecent = data?.[0];
  const maxDate = mostRecent?.dataReferencia ?? '';

  if (isLoading) {
    return (
      <Box>
        <Skeleton
          variant="text"
          width={150}
          height={20}
          sx={{ mb: 1, mt: 3 }}
        />
        <Box sx={{ height: 2, backgroundColor: 'black', mb: 2 }} />
        <Box display="flex" gap={2}>
          <Skeleton variant="rectangular" width="25%" height={150} />
          <Skeleton variant="rectangular" width="25%" height={150} />
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Subtitle title="Dados" />
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1}>
        <DateChip
          title="Competência"
          date={maxDate ? formatDate(maxDate) : 'N/D'}
        />
      </Box>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <PaperPanelInfo
            first
            title="Categoria de Ativo"
            value={mostRecent?.categoriaCarteiraInvestida ?? 'N/D'}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <PaperPanelInfo
            numeric
            title="Ativo"
            value={mostRecent?.valorAtivo ?? 'N/D'}
          />
        </Grid>
      </Grid>
    </>
  );
}
